import { render, staticRenderFns } from "./EditTutorial.vue?vue&type=template&id=58120114&"
import script from "./EditTutorial.vue?vue&type=script&lang=js&"
export * from "./EditTutorial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports